export const showAddPlanModal = () => {
    return {
      type: "SHOW_ADD_Plan_MODAL",
    };
  };
  
  export const hideAddPlanModal = () => {
    return {
      type: "HIDE_ADD_Plan_MODAL",
    };
  };
  